var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"auth-brand text-center text-lg-left"},[_c('a',{staticClass:"logo-dark",attrs:{"href":"javascript: void(0);"}},[_c('span',[_c('img',{attrs:{"src":require("../../design/assets/images/Original_Horizontal_Colored.png"),"alt":"","height":"55"}})])])])
}]

export { render, staticRenderFns }